import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { BlogService } from "../../services/blog.service";
import { UserService } from "../../services/user.service";
import { Title, Meta } from "@angular/platform-browser";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-blog-detail",
  templateUrl: "./blog-detail.component.html",
  styleUrls: ["./blog-detail.component.css"],
  standalone: false,
})
export class BlogDetailComponent implements OnInit {
  blog :any = null;
  notfound = false;
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private blogService: BlogService,
    private metaService: Meta,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private userService: UserService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    let params: any = this.activatedRoute.snapshot.params;
    //console.log(params.id);
    //if(history.state.id) {
    if (params.slug) {
      this.blogService.getBySlug(params.slug).subscribe((res) => {
        if (res.success) {
          this.blog = res.data
          this.notfound = false;
          this.updateMeta()      
        } else {
          this.notfound = true;
          this.userService.errorMessage(res.message);
        }
      });
    } else {
      this.router.navigate(["/blogs"]);
      this.notfound = true;
    }
  }

  updateMeta(){
    this.setTitle(this.blog.title);
    this.userService.addMetaTag('name','keywords','content',this.blog.meta_keyword)
    this.userService.addMetaTag('name','description','content',this.blog.summary)

    this.userService.addMetaTag('property',"og:title",'content',this.blog.title)
    this.userService.addMetaTag('property',"og:url", 'content',`${environment.BASE_URL}/blogs/${this.blog.slug}`);
    this.userService.addMetaTag('property',"og:image", 'content',this.blog.image);
    this.userService.addMetaTag('property','og:image:width','content','500')
    this.userService.addMetaTag('property','og:image:height','content','500')
    this.userService.addMetaTag('property',"og:image:alt", 'content',this.blog.title ?? '');
    this.userService.addMetaTag('property',"og:type", 'content',"blog");

    this.userService.addMetaTag('name',"twitter:card",'content',"summary_large_image" );
    this.userService.addMetaTag('name',"twitter:title",'content',this.blog.title );
    this.userService.addMetaTag('name',"twitter:description",'content',this.blog.summary ?? '' );
    this.userService.addMetaTag('name',"twitter:image",'content',this.blog.image );

  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
}
